import axios from "axios";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { getJsonURL } from "./utilities";
import Header from "./components/Header";
import RetailGuidelines from "./pages/RetailGuidelines";
import GlobalStyles from "./GlobalStyles";
import Loader from "./components/Loader";
import { CookieSetting } from "cookiesetting-component";

function App() {
  const [siteImages, setSiteImages] = useState(null);
  const [siteContent, setSiteContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const Footer = lazy(() => import("./components/Footer/index.js"));
  // const RetailGuidelines = lazy(() => import("./pages/RetailGuidelines/index.js"));
  const [showOtherComponents, setShowOtherComponents] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const getImageJson = async () => {
      try {
        const { data } = await axios.get(getJsonURL("RetailGuidelinesImages.json"));
        setSiteImages(data);
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    };
    getImageJson();
  }, []);

  useEffect(() => {
    if (siteImages) {
      const getSiteContentJson = async () => {
        try {
          const { data } = await axios.get(getJsonURL("RetailGuidelinesContent.json"));
          setSiteContent(data);
          // console.log(data);
        } catch (err) {
          console.log(err);
        }
      };
      getSiteContentJson();
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [siteImages]);

  return (
    <div className="App">
      <GlobalStyles />
      {loading ? (
        <Loader /> // Show the Loader component while loading
      ) : (
        <>
          {siteImages && <Header logo={siteImages?.logo} />}
          {siteImages ? (
            <RetailGuidelines
              siteContent={siteContent}
              siteImages={siteImages}
            />
          ) : null}
          {showOtherComponents && (
            <Suspense fallback={<div />}>
              <Footer />
            </Suspense>
          )}
        </>
      )}
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </div>
  );
}

export default App;
